import {
  eventNotificationsClient,
  type EventNotification,
  type EventNotificationRequest,
  type PaginatedEventNotificationList,
  type ErrorEnvelopeError,
  isErrorEnvelopeError,
} from '@dynatrace-sdk/client-notification-v2';

import {
  useNotificationClient,
  type UseNotificationClientReturn,
} from './useNotificationClient.js';

/**
 * @internal
 */
export function useEventNotificationClient(
  config: EventNotificationRequest,
): UseNotificationClientReturn {
  const notifications = useNotificationClient<
    EventNotificationRequest,
    EventNotification,
    PaginatedEventNotificationList,
    ErrorEnvelopeError
  >('event', config, {
    list: (config, abortSignal) =>
      eventNotificationsClient.getEventNotifications({
        ...config,
        abortSignal,
      }),
    create: (config) =>
      eventNotificationsClient.createEventNotification({
        body: config,
      }),
    destroy: (id) =>
      eventNotificationsClient.deleteEventNotification({
        id,
      }),
    isErrorEnvelopeError,
  });

  return notifications;
}
